var quizQuestions = [
  {
      question: "What is your biggest strength?",
      answers: [
          {
              type: "Microsoft",
              content: "I know my work"
          },
          {
              type: "Nintendo",
              content: "I am a very lucky person"
          },
          {
              type: "Sony",
              content: "I am a hardworker"
          }
      ]
  },
  {
      question: "Why do you deserve this job?",
      answers: [
          {
              type: "Microsoft",
              content: "I need a job"
          },
          {
              type: "Nintendo",
              content: "It is my passion"
          },
          {
              type: "Sony",
              content: "I can make the company money"
          }
      ]
  },
  {
      question: " How would you spice up meetings to boost creativity?",
      answers: [
          {
              type: "Microsoft",
              content: "Meetings don't need creativity"
          },
          {
              type: "Nintendo",
              content: "We play games"
          },
          {
              type: "Sony",
              content: "We let everyone speak their mind"
          }
      ]
  },
  {
      question: "Where do you see yourself in 10 years time?",
      answers: [
          {
              type: "Microsoft",
              content: "Still here"
          },
          {
              type: "Nintendo",
              content: "Started my own business"
          },
          {
              type: "Sony",
              content: "I don't know"
          }
      ]
  },
  {
      question: "What is your dream role in a company?",
      answers: [
          {
              type: "Microsoft",
              content: "CEO"
          },
          {
              type: "Nintendo",
              content: "Any job is fine"
          },
          {
              type: "Sony",
              content: "The next logical promotion"
          }
      ]
  },
  {
       question: "Tell me how you would overcome a situation where a team is doing badly because members aren’t getting along.",
      answers: [
          {
              type: "Microsoft",
              content: "I raise my voice and shout"
          },
          {
              type: "Nintendo",
              content: "I do my own thing"
          },
          {
              type: "Sony",
              content: "We talk it out as a team and resolve the issue"
          }
      ]
  },
  {
       question: "How do you go about rearranging your schedule if something unplanned occurs?",
      answers: [
          {
              type: "Microsoft",
              content: "I write everything down in my diary and update my calendar"
          },
          {
              type: "Nintendo",
              content: "I go with the flow"
          },
          {
              type: "Sony",
              content: "I don't. My day is set in stone."
          }
      ]
  },
   {
       question: "Which one better describes you: ‘done is better than perfect’ or ‘everything has to look perfect’?",
      answers: [
          {
              type: "Microsoft",
              content: "done is better than perfect"
          },
          {
              type: "Nintendo",
              content: "I go with the flow"
          },
          {
              type: "Sony",
              content: "everything has to look perfect"
          }
      ]
  }
];

export default quizQuestions;
